import React, { Component } from "react";
import { connect } from "react-redux";
import { LargePrimaryButton, LargeLinkButton } from "@worthy-npm/clarity";
import {
    diffOnValues,
    dollarsWithoutCents,
    percentageOnValues,
    roundedPrice,
} from "helpers/ApplicationHelper";
import { bindActionCreators } from "redux";
import PopupTooltipSuccessFee from "components/popups/popupTooltipSuccessFee";
import { PopupSimilarItems } from "components/popups/popupSimilarItems";
import PopupAnotherChance from "components/popups/popupAnotherChance";
import { acceptSell } from "actions/item";
import BidsSection from "components/item/bidsSection";
import sendEvents from "lib/events";

import I18n from "lib/i18n/i18n";
class BannersBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            banner: props.item.banner_status,
            buy_it_now: props.item.buy_it_now,
        };

        this.changeBanner = this.changeBanner.bind(this);
        this.approve = this.approve.bind(this);
        this.bidsSection = this.bidsSection.bind(this);
        this.highestBidToShow = this.highestBidToShow.bind(this);
        this.feesSection = this.feesSection.bind(this);
        this.betterBid = this.betterBid.bind(this);
        this.similarItems = this.similarItems.bind(this);
        this.cta = this.cta.bind(this);
        this.afterCta = this.afterCta.bind(this);
        this.smallBanner = this.smallBanner.bind(this);
        this.bannerTitle = this.bannerTitle.bind(this);
    }

    componentDidMount() {
        sendEvents.supportNegotiationEvent(
            this.props.item.id,
            `Banner ${this.state.banner} presented`
        );
        const prefix = "Seller viewed ";
        let msg = "negotiation page";

        switch (this.state.banner) {
            case "pendingResponse":
                msg = "pending offer page";
                break;
            case "lastChance":
                msg =
                    '"No buyer agree to the new price" page - lastChanceNoBuyerFeesBid';
                break;
            case "lastChanceNewOffer":
                msg = '"One buyer submitted a new offer" page';
                break;
            case "shipBack":
                msg = "ship back message page";
                break;
            case "auction_ended":
                if (!this.props.item.in_support_negotiation_threshold)
                    msg = "STD item above threshold screen";
                break;
            default:
                msg = "negotiation page";
                break;
        }
        sendEvents.supportNegotiationEvent(this.props.item.id, prefix + msg);
    }

    changeBanner(val, bin) {
        this.setState({ banner: val, buy_it_now: bin });
        this.props.changeStateTo(val);
        sendEvents.supportNegotiationEvent(
            this.props.item.id,
            `Banner changed to ${this.state.banner} banner`
        );
    }

    bannerTitle() {
        if (this.state.banner === "auction_ended") {
            return (
                <div className="main-text">
                    {I18n.getJsx(
                        `itemPage::supportNegotiation::${this.state.banner}::title`,
                        {
                            type: <span>{this.props.item.type}</span>,
                            interested_buyers: (
                                <span>{this.props.item.interested_buyers}</span>
                            ),
                        }
                    )}
                </div>
            );
        } else {
            return (
                <div className="main-text">
                    {I18n.getString(
                        `itemPage::supportNegotiation::${this.state.banner}::title`
                    )}{" "}
                </div>
            );
        }
    }

    highestBidToShow() {
        let highestBidAfterBuyerFees =
            this.props.item.highest_bid_after_buyer_fees;
        let fakeHighestBid = this.props.item.evaluation_after_buyer_fees;
        let oldHighestBid = this.props.item.old_highest_bid_value;
        if (this.state.banner === "lastChanceNewOffer") {
            return (
                <div>
                    <span className="deleted">
                        {dollarsWithoutCents(oldHighestBid)}
                    </span>{" "}
                    {dollarsWithoutCents(highestBidAfterBuyerFees)}
                </div>
            );
        } else if (this.state.banner === "lastChance") {
            return (
                <div>
                    <span className="deleted">
                        {dollarsWithoutCents(highestBidAfterBuyerFees)}
                    </span>{" "}
                    {dollarsWithoutCents(fakeHighestBid)}
                </div>
            );
        } else if (this.state.banner === "sold") {
            return dollarsWithoutCents(fakeHighestBid);
        } else {
            return dollarsWithoutCents(highestBidAfterBuyerFees);
        }
    }

    bidsSection() {
        return (
            <div className="bids-line">
                <span className="bids-text">
                    {I18n.getString(
                        `itemPage::supportNegotiation::${this.state.banner}::bid`
                    )}
                </span>
                <span className="bids-value">{this.highestBidToShow()}</span>
            </div>
        );
    }

    feesSection() {
        return (
            <div className="fees-section">
                <span>
                    {I18n.getJsx(
                        `itemPage::supportNegotiation::${this.state.banner}::fee`,
                        {
                            successFee: (
                                <a
                                    onClick={() => {
                                        PopupTooltipSuccessFee.initPopup({
                                            item_id: this.props.item.id,
                                            page: "support_negotiation",
                                        });
                                        sendEvents.supportNegotiationEvent(
                                            this.props.item.id,
                                            "Fees link clicked"
                                        );
                                    }}
                                >
                                    {I18n.getString(
                                        `itemPage::supportNegotiation::${this.state.banner}::fee_successFee`
                                    )}
                                </a>
                            ),
                        }
                    )}
                </span>
                {(() => {
                    if (this.state.banner === "sold") {
                        const waved =
                            this.props.item.evaluation_seller_fees < 0;
                        if (waved)
                            return (
                                <span className="bids-value bold">Waived</span>
                            );
                        return (
                            <span className="bids-value">
                                {roundedPrice(
                                    this.props.item.evaluation_seller_fees
                                )}
                                &nbsp;(
                                {this.props.item.seller_fees_in_percentages})
                            </span>
                        );
                    }
                })()}
            </div>
        );
    }

    betterBid() {
        let highestBidAfterBuyerFees =
            this.props.item.highest_bid_after_buyer_fees;
        let fakeHighestBid = this.props.item.evaluation_after_buyer_fees;
        let oldHighestBid = this.props.item.old_highest_bid_value;
        let oldBid;
        let newBid;
        let increasePercentage;
        switch (this.state.banner) {
            case "lastChanceNewOffer":
                oldBid = oldHighestBid;
                newBid = highestBidAfterBuyerFees;
                increasePercentage = percentageOnValues(newBid, oldBid);
                break;
            case "lastChance":
                oldBid = highestBidAfterBuyerFees;
                newBid = fakeHighestBid;
                increasePercentage = percentageOnValues(newBid, oldBid);
                break;
        }
        return (
            <div className="better-bid">
                <span>
                    {I18n.getJsx(
                        `itemPage::supportNegotiation::${this.state.banner}::betterDeal`,
                        {
                            betterDiff: (
                                <span className="green">
                                    {diffOnValues(newBid, oldBid)}
                                    <span className="green percentage">
                                        (
                                        <span className="higher">
                                            {increasePercentage}
                                        </span>
                                        % )
                                    </span>
                                </span>
                            ),
                        }
                    )}
                </span>
            </div>
        );
    }

    similarItems() {
        if (
            this.props.item.similar_items.length > 1 &&
            this.state.banner !== "auction_ended"
        ) {
            return (
                <div className="similar-items">
                    {I18n.getJsx(
                        `itemPage::supportNegotiation::${this.state.banner}::similar`,
                        {
                            similarReplace: (() => {
                                return (
                                    <a
                                        onClick={() => {
                                            PopupSimilarItems.initPopup({
                                                item: this.props.item,
                                            });
                                            sendEvents.supportNegotiationEvent(
                                                this.props.item.id,
                                                `Similar items link clicked - ${this.state.banner}`
                                            );
                                        }}
                                    >
                                        {I18n.getString(
                                            `itemPage::supportNegotiation::${this.state.banner}::similar_similarReplace`
                                        )}
                                    </a>
                                );
                            })(),
                            price1: (
                                <span>
                                    {dollarsWithoutCents(
                                        this.props.item.reserve_price_range[0]
                                    )}
                                </span>
                            ),
                            price2: (
                                <span>
                                    {dollarsWithoutCents(
                                        this.props.item.reserve_price_range[1]
                                    )}
                                </span>
                            ),
                        }
                    )}
                </div>
            );
        }
    }

    cta() {
        return (
            <div className="approve-get-paid">
                <LargePrimaryButton
                    text={I18n.getString(
                        `itemPage::supportNegotiation::${this.state.banner}::cta`
                    )}
                    click={(stopAnimation) => {
                        const bannerName =
                            this.state.banner === "lastChance"
                                ? "lastChanceNoBuyerFeesBid"
                                : this.state.banner;
                        const overThreshold =
                            !this.props.item.in_support_negotiation_threshold;
                        const eventPrefix = "Approve cta clicked - ";
                        const eventMsg = `${bannerName}${
                            overThreshold && bannerName === "auction_ended"
                                ? " item over STD threshold"
                                : ""
                        }`;
                        sendEvents.supportNegotiationEvent(
                            this.props.item.id,
                            eventPrefix + eventMsg
                        );
                        this.approve(stopAnimation);
                    }}
                />
            </div>
        );
    }

    approve(stopBtnAnimation) {
        document.activeElement.blur();
        let submit = () => {
            return this.props.acceptSell(this.props.item.id).then(() => {
                this.changeBanner("sold");
                stopBtnAnimation();
            });
        };
        submit();
    }

    afterCta() {
        return (
            this.props.item.in_support_negotiation_threshold && (
                <div className="additional-link">
                    <LargeLinkButton
                        click={() => {
                            sendEvents.supportNegotiationEvent(
                                this.props.item.id,
                                `Refuse offer clicked - ${this.state.banner}`
                            );
                            PopupAnotherChance.initPopup({
                                changeStateTo: this.changeBanner,
                                item: this.props.item,
                                banner: this.props.banner,
                            });
                        }}
                        text={I18n.getString(
                            `itemPage::supportNegotiation::${this.state.banner}::refuse`
                        )}
                    />
                </div>
            )
        );
    }

    smallBanner() {
        if (
            [
                "lastChance",
                "pendingResponse",
                "shipBack",
                "lastChanceNewOffer",
            ].includes(this.state.banner)
        ) {
            return (
                <div className="additional-banner">
                    <div className="main-text">
                        {I18n.getJsx(
                            `itemPage::supportNegotiation::${this.state.banner}::small_banner_title`,
                            {
                                type: (
                                    <span>
                                        {this.state.banner ===
                                            "pendingResponse" &&
                                        this.state.buy_it_now
                                            ? dollarsWithoutCents(
                                                  this.state.buy_it_now[0]
                                              )
                                            : ""}
                                    </span>
                                ),
                                tel: (
                                    <a
                                        href="tel:1 (888) 222-0208"
                                        className="tel"
                                    >
                                        1 (888) 222-0208
                                    </a>
                                ),
                            }
                        )}
                    </div>
                </div>
            );
        }
    }

    render() {
        return (
            <div id="auction-banner">
                <div className={`${this.state.banner} additional-banner`}>
                    {this.smallBanner()}
                </div>
                {(() => {
                    if (
                        !["pendingResponse", "shipBack"].includes(
                            this.state.banner
                        )
                    ) {
                        return (
                            <div className={this.state.banner}>
                                {!["lastChance", "lastChanceNewOffer"].includes(
                                    this.state.banner
                                )
                                    ? this.bannerTitle()
                                    : ""}
                                {this.bidsSection()}
                                {this.feesSection()}
                                {this.betterBid()}
                                {this.similarItems()}
                                {this.cta()}
                                {this.afterCta()}
                            </div>
                        );
                    }
                })()}
                <BidsSection
                    item={this.props.item}
                    banner={this.state.banner}
                    className="desktop"
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ acceptSell }, dispatch);
};

export default connect(null, mapDispatchToProps)(BannersBox);
